import React from 'react';
import { View, ViewStyle } from 'react-native';

import { useTheme } from '@/components/theme-provider';

export interface DividerProps {
	style?: ViewStyle;
	horizontal?: boolean;
	thickness?: number;
}

export const Divider: React.FC<DividerProps> = ({
	style,
	horizontal = true,
	thickness = 1,
}) => {
	const theme = useTheme();

	const dividerStyle: ViewStyle = {
		backgroundColor: theme.colors.outline,
		...(horizontal
			? {
				height: thickness,
				width: '100%',
			  }
			: {
				width: thickness,
				height: '100%',
			  }),
	};

	return <View style={[dividerStyle, style]} />;
};
